import React from 'react';
import { CheckIcon, SparklesIcon } from 'lucide-react';
const PricingSection = () => {
  return <section id="pricing" className="py-4 opacity-5 pointer-events-none h-16 overflow-hidden" aria-hidden="true" data-id="element-383">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-384">
        <div className="text-center" data-id="element-385">
          <h2 className="text-sm font-bold text-[#E87B5C]" data-id="element-386">
            Premium features coming soon
          </h2>
        </div>
        {/* Hidden pricing content preserved for future use */}
        <div className="hidden" data-id="element-387">
          {/* Two-column pricing cards */}
          <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-388">
            {/* Free Plan */}
            <div className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden border border-gray-200" data-id="element-389">
              <div className="p-8 md:p-10" data-id="element-390">
                {/* Header with price */}
                <div className="text-center mb-8" data-id="element-391">
                  <div className="inline-flex items-center justify-center mb-3" data-id="element-392">
                    <h3 className="text-2xl font-bold text-gray-800" data-id="element-393">
                      Free Plan
                    </h3>
                  </div>
                  <p className="text-4xl font-bold text-gray-900" data-id="element-394">
                    $0{' '}
                    <span className="text-base font-normal text-gray-500" data-id="element-395">
                      forever
                    </span>
                  </p>
                </div>
                {/* CTA Button */}
                <div className="mb-10" data-id="element-396">
                  <a href="#" className="block w-full py-4 px-6 bg-gray-100 text-gray-800 text-center text-lg font-medium rounded-full hover:bg-gray-200 transition-all" data-id="element-397">
                    Get Started
                  </a>
                </div>
                {/* Divider */}
                <div className="relative my-8" data-id="element-398">
                  <div className="absolute inset-0 flex items-center" data-id="element-399">
                    <div className="w-full border-t border-gray-200" data-id="element-400"></div>
                  </div>
                  <div className="relative flex justify-center" data-id="element-401">
                    <span className="bg-white px-4 text-sm text-gray-500" data-id="element-402">
                      Free Features
                    </span>
                  </div>
                </div>
                {/* Features List */}
                <div className="space-y-4" data-id="element-403">
                  <div className="flex items-start" data-id="element-404">
                    <div className="flex-shrink-0 h-6 w-6 rounded-full bg-gray-100 flex items-center justify-center mr-3" data-id="element-405">
                      <CheckIcon className="h-4 w-4 text-gray-600" data-id="element-406" />
                    </div>
                    <span className="text-base text-gray-700" data-id="element-407">
                      Basic reframing suggestions
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-408">
                    <div className="flex-shrink-0 h-6 w-6 rounded-full bg-gray-100 flex items-center justify-center mr-3" data-id="element-409">
                      <CheckIcon className="h-4 w-4 text-gray-600" data-id="element-410" />
                    </div>
                    <span className="text-base text-gray-700" data-id="element-411">
                      Simple tone detection
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-412">
                    <div className="flex-shrink-0 h-6 w-6 rounded-full bg-gray-100 flex items-center justify-center mr-3" data-id="element-413">
                      <CheckIcon className="h-4 w-4 text-gray-600" data-id="element-414" />
                    </div>
                    <span className="text-base text-gray-700" data-id="element-415">
                      5 reframes per day
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-416">
                    <div className="flex-shrink-0 h-6 w-6 rounded-full bg-gray-100 flex items-center justify-center mr-3" data-id="element-417">
                      <CheckIcon className="h-4 w-4 text-gray-600" data-id="element-418" />
                    </div>
                    <span className="text-base text-gray-700" data-id="element-419">
                      Community support
                    </span>
                  </div>
                </div>
              </div>
            </div>
            {/* Premium Plan */}
            <div className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300 overflow-hidden border border-[#E87B5C]/20 relative" data-id="element-420">
              {/* Popular badge */}
              <div className="absolute top-0 right-0 bg-gradient-to-r from-[#E87B5C] to-[#FFD700] text-white text-xs font-bold px-4 py-1 rounded-bl-lg" data-id="element-421">
                MOST POPULAR
              </div>
              <div className="p-8 md:p-10" data-id="element-422">
                {/* Header with price */}
                <div className="text-center mb-8" data-id="element-423">
                  <div className="inline-flex items-center justify-center mb-3" data-id="element-424">
                    <SparklesIcon className="h-6 w-6 text-[#FFD700] mr-2" data-id="element-425" />
                    <h3 className="text-2xl font-bold text-[#E87B5C]" data-id="element-426">
                      Premium Plan
                    </h3>
                  </div>
                  <p className="text-4xl font-bold text-gray-900" data-id="element-427">
                    $9.99{' '}
                    <span className="text-base font-normal text-gray-500" data-id="element-428">
                      per month
                    </span>
                  </p>
                </div>
                {/* CTA Button */}
                <div className="mb-10" data-id="element-429">
                  <a href="#" className="block w-full py-4 px-6 bg-gradient-to-r from-[#E87B5C] to-[#E87B5C]/90 text-white text-center text-lg font-medium rounded-full hover:shadow-md transition-all transform hover:-translate-y-0.5" data-id="element-430">
                    Upgrade Now
                  </a>
                </div>
                {/* Divider */}
                <div className="relative my-8" data-id="element-431">
                  <div className="absolute inset-0 flex items-center" data-id="element-432">
                    <div className="w-full border-t border-gray-200" data-id="element-433"></div>
                  </div>
                  <div className="relative flex justify-center" data-id="element-434">
                    <span className="bg-white px-4 text-sm text-gray-500" data-id="element-435">
                      Premium Features
                    </span>
                  </div>
                </div>
                {/* Features List */}
                <div className="space-y-4" data-id="element-436">
                  <div className="flex items-start" data-id="element-437">
                    <div className="flex-shrink-0 h-6 w-6 rounded-full bg-[#E87B5C]/10 flex items-center justify-center mr-3" data-id="element-438">
                      <CheckIcon className="h-4 w-4 text-[#E87B5C]" data-id="element-439" />
                    </div>
                    <span className="text-base text-gray-700" data-id="element-440">
                      Everything in Free
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-441">
                    <div className="flex-shrink-0 h-6 w-6 rounded-full bg-[#E87B5C]/10 flex items-center justify-center mr-3" data-id="element-442">
                      <CheckIcon className="h-4 w-4 text-[#E87B5C]" data-id="element-443" />
                    </div>
                    <span className="text-base text-gray-700" data-id="element-444">
                      Unlimited reframes
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-445">
                    <div className="flex-shrink-0 h-6 w-6 rounded-full bg-[#E87B5C]/10 flex items-center justify-center mr-3" data-id="element-446">
                      <CheckIcon className="h-4 w-4 text-[#E87B5C]" data-id="element-447" />
                    </div>
                    <span className="text-base text-gray-700" data-id="element-448">
                      Advanced analytics
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-449">
                    <div className="flex-shrink-0 h-6 w-6 rounded-full bg-[#E87B5C]/10 flex items-center justify-center mr-3" data-id="element-450">
                      <CheckIcon className="h-4 w-4 text-[#E87B5C]" data-id="element-451" />
                    </div>
                    <span className="text-base text-gray-700" data-id="element-452">
                      Personalized insights
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-453">
                    <div className="flex-shrink-0 h-6 w-6 rounded-full bg-[#E87B5C]/10 flex items-center justify-center mr-3" data-id="element-454">
                      <CheckIcon className="h-4 w-4 text-[#E87B5C]" data-id="element-455" />
                    </div>
                    <span className="text-base text-gray-700" data-id="element-456">
                      Emotional tracking
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-457">
                    <div className="flex-shrink-0 h-6 w-6 rounded-full bg-[#E87B5C]/10 flex items-center justify-center mr-3" data-id="element-458">
                      <CheckIcon className="h-4 w-4 text-[#E87B5C]" data-id="element-459" />
                    </div>
                    <span className="text-base text-gray-700" data-id="element-460">
                      Priority support
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-12 text-center" data-id="element-461">
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-462">
              All premium features are designed to help you manage emotions and
              communicate more effectively. Start with a 7-day free trial, no
              credit card required.
            </p>
          </div>
        </div>
      </div>
    </section>;
};
export default PricingSection;